import { BusinessValidationError } from '../errors/BusinessValidationError';
import { ValidationError } from '../errors/ValidationError';
export function getErrorMessage(error, fallback) {
    if (error instanceof BusinessValidationError) {
        return fallback;
    }
    if (error instanceof ValidationError) {
        const joined = error.allMessages.join('\n');
        return joined.length > 0 ? joined : fallback;
    }
    return fallback;
}
